import React, { useState, useEffect } from 'react';
import { fetchActiveLabs } from '../ApiHandler/labFunctions';
import { toast } from 'react-toastify';
import Axios from 'axios';
import './studentReports.css';

const API_URL = process.env.REACT_APP_API_URL;

const StudentReports = () => {
    const [labs, setLabs] = useState([]);
    const [selectedLabId, setSelectedLabId] = useState('');
    const [filters, setFilters] = useState({
        reportType: 'Student Registration',
        sortBy: 'Registration Date (Newest)',
        state: '',
        district: '',
        schoolName: '',
        gender: 'All',
        socialGroup: 'All',
        studentClass: '',
        exam: 'All',
        fromDate: '',
        toDate: ''
    });

    useEffect(() => {
        fetchActiveLabs(setLabs);
    }, []);

    const handleChange = (e) => setFilters({ ...filters, [e.target.name]: e.target.value });

    const handleDownload = async () => {
        if (!selectedLabId) return toast.error('Please select a Lab first');
        
        try {
            toast.info('Generating report...');
            // We reuse the existing students excel endpoint but pass granular filters
            let url = `${API_URL}/students/download-excel?lab_id=${selectedLabId}&reportType=${encodeURIComponent(filters.reportType)}`;
            if (filters.state) url += `&state=${encodeURIComponent(filters.state)}`;
            if (filters.district) url += `&district=${encodeURIComponent(filters.district)}`;
            if (filters.schoolName) url += `&schoolName=${encodeURIComponent(filters.schoolName)}`;
            if (filters.gender !== 'All') url += `&gender=${encodeURIComponent(filters.gender)}`;
            if (filters.socialGroup !== 'All') url += `&socialGroup=${encodeURIComponent(filters.socialGroup)}`;
            if (filters.studentClass) url += `&studentClass=${encodeURIComponent(filters.studentClass)}`;
            if (filters.exam !== 'All') url += `&exam=${encodeURIComponent(filters.exam)}`;
            if (filters.fromDate) url += `&fromDate=${encodeURIComponent(filters.fromDate)}`;
            if (filters.toDate) url += `&toDate=${encodeURIComponent(filters.toDate)}`;

            const res = await Axios.get(url, {
                headers: { Authorization: localStorage.getItem('token') },
                responseType: 'blob'
            });

            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Advanced_Student_Report_${new Date().getTime()}.xlsx`;
            link.click();
            toast.success('Report downloaded');
        } catch (error) {
            console.error('Download error:', error);
            toast.error('Failed to download report');
        }
    };

    return (
        <div className="student-reports-page">
            <div className="header-row">
                <h2>Student Advanced Reports & Exports</h2>
                <select value={selectedLabId} onChange={e => setSelectedLabId(e.target.value)} className="lab-dropdown">
                    <option value="">-- Select Lab --</option>
                    {labs.map(l => <option key={l.id} value={l.id}>{l.lab_name}</option>)}
                </select>
            </div>

            {selectedLabId ? (
                <div className="reports-box">
                    <h3 className="filter-title">Filter Data</h3>
                    
                    <div className="filter-grid">
                        <div className="input-group">
                            <label>Report Type</label>
                            <select name="reportType" value={filters.reportType} onChange={handleChange}>
                                <option value="Student Registration">Student Registration</option>
                                <option value="Assessment Details">Assessment Details</option>
                                <option value="Combined Students & Assessments">Combined Students & Assessments</option>
                                <option value="Kendra Details">Kendra Details</option>
                            </select>
                        </div>
                        <div className="input-group">
                            <label>Sort By</label>
                            <select name="sortBy" value={filters.sortBy} onChange={handleChange}>
                                <option value="Registration Date (Newest)">Registration Date (Newest)</option>
                                <option value="Registration Date (Oldest)">Registration Date (Oldest)</option>
                                <option value="Name (A-Z)">Name (A-Z)</option>
                            </select>
                        </div>

                        <div className="input-group">
                            <label>State</label>
                            <input type="text" name="state" placeholder="e.g. Rajasthan" value={filters.state} onChange={handleChange} />
                        </div>
                        <div className="input-group">
                            <label>District</label>
                            <input type="text" name="district" value={filters.district} onChange={handleChange} />
                        </div>
                        <div className="input-group">
                            <label>School Name</label>
                            <input type="text" name="schoolName" value={filters.schoolName} onChange={handleChange} />
                        </div>
                        <div className="input-group">
                            <label>Gender</label>
                            <select name="gender" value={filters.gender} onChange={handleChange}>
                                <option value="All">All</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        <div className="input-group">
                            <label>Social Group</label>
                            <select name="socialGroup" value={filters.socialGroup} onChange={handleChange}>
                                <option value="All">All</option>
                                <option value="General">General</option>
                                <option value="OBC">OBC</option>
                                <option value="SC">SC</option>
                                <option value="ST">ST</option>
                            </select>
                        </div>
                        <div className="input-group">
                            <label>Class</label>
                            <input type="text" name="studentClass" value={filters.studentClass} onChange={handleChange} />
                        </div>
                        <div className="input-group">
                            <label>Exam</label>
                            <select name="exam" value={filters.exam} onChange={handleChange}>
                                <option value="All">All</option>
                                <option value="JEE">JEE</option>
                                <option value="NEET">NEET</option>
                                <option value="CUET">CUET</option>
                                <option value="BOARD">BOARD</option>
                            </select>
                        </div>
                        <div className="input-group"></div>

                        <div className="input-group">
                            <label>From Date</label>
                            <input type="date" name="fromDate" value={filters.fromDate} onChange={handleChange} />
                        </div>
                        <div className="input-group">
                            <label>To Date</label>
                            <input type="date" name="toDate" value={filters.toDate} onChange={handleChange} />
                        </div>
                    </div>

                    <div className="download-row">
                        <button onClick={handleDownload} className="download-excel-btn">
                            <i className="bx bx-download"></i> Download Excel
                        </button>
                    </div>
                </div>
            ) : (
                <div className="kendra-placeholder">Please select a Lab to view its reports.</div>
            )}

            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid #6C5CE7', fontSize: '13px', color: '#555' }}>
                <i className='bx bx-shield-quarter' style={{ marginRight: '8px', color: '#6C5CE7' }}></i>
                <strong>Role-Based Access:</strong> To ensure data privacy, Teachers can only export records mapped to their assigned Lab or School, or records they have personally added. District Officers can export all records within their assigned District. Admin has global access.
            </div>
        </div>
    );
};

export default StudentReports;
